import ConfirmDialog from '../../components/common/ConfirmDialog';
import warningIcon from '../../assets/confirmation-warning.svg';
import infoIcon from '../../assets/confirmation-info.svg';

export type LenderStatusAction = 'activate' | 'deactivate';

interface LenderStatusDialogProps {
  action: LenderStatusAction;
  lenderName: string;
  isPending: boolean;
  errorMessage: string | null;
  onConfirm: () => void | Promise<void>;
  onCancel: () => void;
}

interface LenderStatusDialogContent {
  verb: string;
  message: string;
  secondaryMessage?: string;
  confirmLabel: string;
  confirmClassName: string;
}

const baseActionClassName =
  'inline-flex h-11 w-full items-center justify-center whitespace-nowrap rounded-lg border px-6 text-[15px] font-semibold leading-6 transition-colors focus-visible:outline focus-visible:outline-2 focus-visible:outline-brand disabled:cursor-not-allowed disabled:opacity-50 sm:shrink-0';

const dialogContent: Record<LenderStatusAction, LenderStatusDialogContent> = {
  deactivate: {
    verb: 'Deactivate',
    message: 'Deactivating this lender blocks new orders and sign-ins for its users.',
    secondaryMessage: 'You can reactivate at any time.',
    confirmLabel: 'Deactivate Lender',
    confirmClassName: `${baseActionClassName} border-[#c62828] bg-white text-[#c62828] hover:bg-red-50 sm:w-[187px]`,
  },
  activate: {
    verb: 'Activate',
    message: 'Activating this lender restores ordering and access for its users.',
    confirmLabel: 'Activate Lender',
    confirmClassName: `${baseActionClassName} border-[#3a149e] bg-[#3a149e] text-white hover:bg-brand sm:w-[198px]`,
  },
};

export default function LenderStatusDialog({
  action,
  lenderName,
  isPending,
  errorMessage,
  onConfirm,
  onCancel,
}: LenderStatusDialogProps) {
  const content = dialogContent[action];
  return <ConfirmDialog open appearance="centered" variant={action === 'deactivate' ? 'danger' : 'default'}
    title={`${content.verb} ${lenderName}?`} message={content.message} secondaryMessage={content.secondaryMessage}
    confirmLabel={content.confirmLabel} confirmClassName={content.confirmClassName}
    messageClassName={action === 'activate' ? 'sm:min-h-[59px]' : undefined}
    icon={action === 'deactivate' ? <img src={warningIcon} width="36" height="36" alt="" /> : <img src={infoIcon} width="24" height="27.4286" alt="" />}
    closeLabel={action === 'deactivate' ? 'Close' : undefined}
    isPending={isPending} errorMessage={errorMessage} onConfirm={onConfirm} onCancel={onCancel} />;
}
